// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__Yoriw","dialog":"Modal_dialog__rEOQr","close":"Modal_close__qBoNJ","lobby":"Modal_lobby__QPfHM"};